import { configureStore } from "@reduxjs/toolkit";
import { detailsReducer } from "./slices/details.slice";

export const store = configureStore({
  reducer: {
    details: detailsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
